import isNil from 'lodash/isNil';
import React from 'react';
import { Link } from 'react-router-dom';

import routeFactory from '../../../../../../common/util/routeFactory';
import type {
  CalendarGridCustomCellRendererProps,
  CalendarGridRowData,
} from '../../CalendarGrid.model';

export type Value = NonNullable<CalendarGridRowData['lastAllocation']>['shares'];

export type AllocationSharesCellRendererProps = CalendarGridCustomCellRendererProps<Value>;

export const AllocationSharesCellRenderer: React.FC<AllocationSharesCellRendererProps> = ({
  data,
  value,
  valueFormatted,
}) => {
  if (!data?.id || isNil(value)) {
    return <React.Fragment>{valueFormatted}</React.Fragment>;
  }

  return <Link to={routeFactory.ioi.getUrlPath({ id: data.id })}>{valueFormatted}</Link>;
};
